import {
  bundleIcon,
  AppsList24Filled,
  AppsList24Regular,
  AppsListDetail24Filled,
  AppsListDetail24Regular,
  Ruler24Regular,
  Ruler24Filled,
  Circle24Regular,
  Circle24Filled,
  AddCircle24Filled,
  AddCircle24Regular,
  Megaphone24Filled,
  Megaphone24Regular,
  TargetArrow24Filled,
  People24Filled,
  People24Regular,
  TargetArrow24Regular,
  Rename24Filled,
  Rename24Regular,
  DrawImage24Filled,
  DrawImage24Regular,
  ArrowImport24Filled,
  ArrowImport24Regular,
  DatabaseLightning20Filled,
  DatabaseLightning20Regular,
  AppGeneric24Filled,
  AppGeneric24Regular,
  ShoppingBag24Filled,
  ShoppingBag24Regular,
  CheckmarkStarburst24Filled,
  CheckmarkStarburst24Regular,
  Luggage24Filled,
  Luggage24Regular,
  Location24Filled,
  Location24Regular,
  StoreMicrosoft24Filled,
  StoreMicrosoft24Regular,
  MoneyCalculator24Filled,
  MoneyCalculator24Regular,
  TextBulletListSquare24Filled,
  TextBulletListSquare24Regular,
  TagMultiple24Regular,
  TagMultiple24Filled,
  SearchInfo24Filled,
  SearchInfo24Regular,
  DataTrending24Filled,
  DataTrending24Regular,
  ProhibitedNote20Filled,
  ProhibitedNote20Regular,
  Organization24Filled,
  Organization24Regular,
  ChartMultiple24Filled,
  ChartMultiple24Regular,
  PersonAccounts24Filled,
  PersonAccounts24Regular,
  WalletCreditCard24Filled,
  WalletCreditCard24Regular,
  Settings24Filled,
  Settings24Regular,
  Shield24Regular,
  Shield24Filled,
} from '@fluentui/react-icons';

import { navRefreshPageIds } from '@bingads-webui-react/with-site-map';

import { Icon, SitemapItem } from './types';

export const AllToolsId = 'allTools';

export const FallbackIcon: Icon = bundleIcon(Circle24Filled, Circle24Regular);

export const NavItemsIconMapping: Record<string, Icon> = {
  [navRefreshPageIds.create]: bundleIcon(AddCircle24Filled, AddCircle24Regular),
  [navRefreshPageIds.advertise]: bundleIcon(Megaphone24Filled, Megaphone24Regular),
  [navRefreshPageIds.audiences]: bundleIcon(People24Filled, People24Regular),
  [navRefreshPageIds.conversions]: bundleIcon(TargetArrow24Filled, TargetArrow24Regular),
  [navRefreshPageIds.keywords]: bundleIcon(Rename24Filled, Rename24Regular),
  [navRefreshPageIds.assetLibrary]: bundleIcon(DrawImage24Filled, DrawImage24Regular),
  [navRefreshPageIds.imports]: bundleIcon(ArrowImport24Filled, ArrowImport24Regular),
  [navRefreshPageIds.businessData]: bundleIcon(DatabaseLightning20Filled, DatabaseLightning20Regular),
  [navRefreshPageIds.smartPage]: bundleIcon(AppGeneric24Filled, AppGeneric24Regular),
  [navRefreshPageIds.merchantCenter]: bundleIcon(ShoppingBag24Filled, ShoppingBag24Regular),
  [navRefreshPageIds.brands]: bundleIcon(CheckmarkStarburst24Filled, CheckmarkStarburst24Regular),
  [navRefreshPageIds.productFeed]: bundleIcon(CheckmarkStarburst24Filled, CheckmarkStarburst24Regular),
  [navRefreshPageIds.hotel]: bundleIcon(Luggage24Filled, Luggage24Regular),
  [navRefreshPageIds.hotelV2]: bundleIcon(Luggage24Filled, Luggage24Regular),
  [navRefreshPageIds.businessLocation]: bundleIcon(Location24Filled, Location24Regular),
  [navRefreshPageIds.microsoftStoreAds]: bundleIcon(StoreMicrosoft24Filled, StoreMicrosoft24Regular),
  [navRefreshPageIds.brandLists]: bundleIcon(AppsList24Filled, AppsList24Regular),
  [navRefreshPageIds.budgetAndBid]: bundleIcon(MoneyCalculator24Filled, MoneyCalculator24Regular),
  [navRefreshPageIds.bulkActions]: bundleIcon(TextBulletListSquare24Filled, TextBulletListSquare24Regular),
  [navRefreshPageIds.labels]: bundleIcon(TagMultiple24Filled, TagMultiple24Regular),
  [navRefreshPageIds.preview]: bundleIcon(SearchInfo24Filled, SearchInfo24Regular),
  [navRefreshPageIds.performanceTargets]: bundleIcon(DataTrending24Filled, DataTrending24Regular),
  [navRefreshPageIds.websiteExclusion]: bundleIcon(ProhibitedNote20Filled, ProhibitedNote20Regular),
  [navRefreshPageIds.brandSafetyControls]: bundleIcon(Shield24Filled, Shield24Regular),
  [navRefreshPageIds.accountMap]: bundleIcon(Organization24Filled, Organization24Regular),
  [navRefreshPageIds.reports]: bundleIcon(ChartMultiple24Filled, ChartMultiple24Regular),
  [navRefreshPageIds.liftMeasurement]: bundleIcon(Ruler24Filled, Ruler24Regular),
  [navRefreshPageIds.allAccounts]: bundleIcon(PersonAccounts24Filled, PersonAccounts24Regular),
  [navRefreshPageIds.billing]: bundleIcon(WalletCreditCard24Filled, WalletCreditCard24Regular),
  [navRefreshPageIds.settings]: bundleIcon(Settings24Filled, Settings24Regular),
  [navRefreshPageIds.adStudio]: bundleIcon(DrawImage24Filled, DrawImage24Regular),
  [AllToolsId]: bundleIcon(AppsListDetail24Filled, AppsListDetail24Regular),
};

export const FixedPinedNavItems: string[] = [
  navRefreshPageIds.advertise,
  navRefreshPageIds.clarity,
  navRefreshPageIds.create,
  navRefreshPageIds.settings,
  AllToolsId,
];

export const StaticNavItems: Record<string, SitemapItem> = {
  allTools: {
    id: AllToolsId,
    name: _TL_('Tools'),
    description: _TL_(''),
    fixed: true,
    scope: null,
    onPinToggle: () => {},
  },
};

export const CreateGroupItemIds: string[] = [
  navRefreshPageIds.create,
];

export const AllToolsGroupItemIds: string[] = [
  AllToolsId,
];
